import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ alignStart?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.alignStart ? 'flex-start' : 'center')};
  justify-content: center;
  row-gap: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #697180;
  white-space: nowrap;
`;
